import { render, staticRenderFns } from "./TravelerTypes.vue?vue&type=template&id=a6200d98&"
import script from "./TravelerTypes.vue?vue&type=script&lang=js&"
export * from "./TravelerTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports